export default "__VITE_ASSET__01d63e0b__"